import React from 'react';
import CostCenterInfiniteSelectField from '@/components/_common/CostCenterInfiniteSelectField';
import {
  FloatingFormItem,
  InputDate,
  InputDecimal,
  PlanAccountsSelect,
} from '@/components/_common';
import {
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { PurchaseFinancialFormValues } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage/PurchaseFinancialPage';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Col, Form, FormInstance, Row } from 'antd';

interface Props {
  form: FormInstance<PurchaseFinancialFormValues>;
}

const InstallmentFormFields: React.FC<Props> = ({ form }) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const { purchase } = useReleasePurchaseFormContext();

  return (
    <Form form={form} name="purchaseFinancialForm">
      <Row gutter={[12, 12]}>
        <Col span={24} md={6} lg={5} xl={3}>
          <FloatingFormItem name="totalAmount" label="Valor total">
            <InputDecimal disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={9} lg={8} xl={8}>
          <FloatingFormItem
            name="planAccountId"
            label="Plano de contas"
            rules={[defaultEmptyFieldError]}
          >
            <PlanAccountsSelect
              allowClear
              queryFilter={{
                hierarchy: PlanAccountHierarchy.Analitical,
                destination: PlanAccountDestination.Expense,
                active: true,
              }}
              disabled={purchase?.boschMigration}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={9} lg={6} xl={6}>
          <FloatingFormItem name="costCenterId" label="Centro de custo">
            <CostCenterInfiniteSelectField
              queryFilter={{ active: true }}
              disabled={purchase?.boschMigration}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={6} lg={5} xl={3}>
          <FloatingFormItem
            name="installmentsFirstDueDate"
            label="Venc. 1º parcela"
            rules={[defaultEmptyFieldError]}
          >
            <InputDate disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={9} lg={5} xl={2}>
          <FloatingFormItem
            name="quantityInstallments"
            label="Qtde. parcelas"
            initialValue={1}
            rules={[{ type: 'number', min: 1 }, defaultEmptyFieldError]}
          >
            <InputDecimal fractions={0} disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={9} lg={5} xl={2}>
          <FloatingFormItem
            name="intervalDays"
            label="Intervalo(dias)"
            initialValue={30}
            rules={[defaultEmptyFieldError]}
          >
            <InputDecimal fractions={0} disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default InstallmentFormFields;
